import { types } from 'mobx-state-tree'
import { simple_api_request } from '../api/simple_api_request'
import object_value from '../api/object_value'

// noinspection JSCheckFunctionSignatures
const RateExperienceStore = types.model({
  status: types.maybe(types.string),
  status_message: types.maybe(types.string),
  current_step: types.optional(types.number, 1),
  // steps: types.maybe(types.array),
  experience_id: types.maybe(types.number),
  event_id: types.maybe(types.number),
  general: types.maybe(types.number),
  price: types.maybe(types.number),
  organiser: types.maybe(types.number),
  text: types.maybe(types.string)
}).actions(
  /**
   * @param {Object} self
   * @returns {Object}
   */
  self => ({
    set (key, value) {
      console.log('RateExperienceStore - set() - key, value:', key, value)
      self[key] = value
    },
    clean () {
      console.log('RateExperienceStore - clean()')
      self.status = null
      self.current_step = 1
      self.steps = [
        'Allgemein', // General
        'Details',
        'Nachricht' // Text
      ]
      self.experience_id = null
      self.event_id = null
      self.general = null
      self.price = null
      self.organiser = null
      self.text = null
      console.log('RateExperienceStore - clean() - cleaned self:', self)
    },
    restart_form () {
      console.log('RateExperienceStore - restart_form()')
      self.status = null
      self.current_step = 1
    },
    request (token) {
      const {
        experience_id,
        event_id,
        general,
        price,
        organiser,
        text
      } = self

      const data = {
        experience_id,
        event_id,
        general,
        price,
        organiser,
        text
      }

      self.status = 'loading'

      simple_api_request({
        path: '/api/rate/experience/',
        data,
        header_token: token
      }).then(
        self.process_response
      )
    },
    process_response (result) {
      console.log('RateExperienceStore - process_response() - result:', result)

      if (result.ok) {
        self.status = 'success'
      } else {
        let message = result.data.message
        let errors = object_value(result, 'data.errors', {})
        if (errors !== null && typeof errors === 'object') {
          for (let [key, value] of Object.entries(errors)) {
            if (value.length > 0) {
              let fetch_text = ''

              value.forEach(t => {
                fetch_text = fetch_text + t + '<br>'
              })

              message = message + `<br><strong>${key}</strong>:<br>${fetch_text}`
            }
          }
        }

        self.status = 'error'
        self.status_message = message
      }
    }
  })
)

export default RateExperienceStore



// WEBPACK FOOTER //
// ./src/stores/RateExperienceStore.js